import { createContext, useContext, useState, useEffect } from "react";
import ReactDOM from "react-dom";

const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
    const [modalContent, setModalContent] = useState(null);

    const showModal = (content) => setModalContent(content);
    const closeModal = () => setModalContent(null);

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === "Escape") {
                closeModal();
            }
        };
        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, []);

    return (
        <ModalContext.Provider value={{ showModal, closeModal }}>
            {children}
            {modalContent &&
                ReactDOM.createPortal(
                    <ModalComponent content={modalContent} closeModal={closeModal} />,
                    document.body
                )}
        </ModalContext.Provider>
    );
};

const ModalComponent = ({ content, closeModal }) => {
    return (
        <div className="modal-overlay" onClick={closeModal}>
            <div className="modal-container" onClick={(e) => e.stopPropagation()}>
                <button className="modal-close" onClick={closeModal}>✖</button>
                {content}
            </div>
        </div>
    );
};

export const useModal = () => useContext(ModalContext);
